import * as Sentry from '@sentry/vue'

import { parseErrorResponseMessage } from '@/utilities/error-responses'

export const handleError = e => {
  // ignore if request was canceled
  if (!e.response) return

  Sentry.captureException(e)

  // Create a more descriptive error object to prevent minified variable issues
  const errorResponse = {
    data: e.response.data || {},
    status: e.response.status || 500,
    statusText: e.response.statusText || 'Unknown Error',
    message: parseErrorResponseMessage(e.response) || e.message || 'An unexpected error occurred',
  }

  throw errorResponse
}
